import { CITE_THIS_FOR_ME } from '../types';
import { getJwt } from '../util/jwtLocalstorage';
import { resetAndInitialize } from './app';
export var redirectToDemo = function redirectToDemo() {
  return function (dispatch, getState) {
    var _getState = getState(),
      editorBaseUrl = _getState.editorBaseUrl,
      site = _getState.site;
    var token = getJwt();
    // TODO: `/demo/plagiarism` is not accounted for in CWC, review `upload-widget-demo` optimizely feature related code here and in other codebases
    var path = "/demo/plagiarism/";
    var query = "?token=".concat(token);
    var redirectUrl = "".concat(editorBaseUrl).concat(path).concat(query);
    if (site == CITE_THIS_FOR_ME) {
      window.open(redirectUrl, '_blank');
      dispatch(resetAndInitialize());
    } else {
      window.open(redirectUrl, '_blank');
    }
  };
};